<!-- presupuesto -->

@if(activeSettingDepartament){
<h1 class="page-header"><i class="fas fa-cog"></i> Configuración <small>Departamento {{filter.departamentItemCode}} - Fondo {{fundSelect}}</small> </h1>

    <app-setting-field-departament [departamentFilter]="filter.departamentItemCode" [year]="filter.year" [fundCode]="fundSelect"
        [version]="filter.version"
        [employeeType]="-1"
        (activeChange)="changeSettingDepartament();activeSettingDepartament=$event;title='Configurar Departamento'"></app-setting-field-departament>

}


@if(activeSettingAccount){
<h1 class="page-header"><i class="fas fa-cog"></i> Configuración <small> Cuentas {{filter.departamentItemCode}} - Fondo {{fundSelect}}</small> </h1>

    <app-setting-field-account [accountFilter]="filter.departamentItemCode" [year]="filter.year" 
    [fundCode]="fundSelect"
    [version]="filter.version"
    (activeChange)="changeSettingAccount();activeSettingAccount=$event;title='Configurar Cuenta'"></app-setting-field-account>

}

@if(!activeSettingAccount && !activeSettingDepartament){



<div class="row">
    <div class="col-12" [ngClass]="{'col-md-6': budgetFund?.length==1,'col-md-12': budgetFund?.length>1}">
        <h1 class="page-header"><i class="fas fa-file-signature"></i>
            @if(accounts.length > 0){ {{accounts[0].itemDisplayName}} }
         </h1>

    </div>
    @if(budgetFund?.length>1){
        <div class="col-12  mb-3" [ngClass]="{'col-md-6': budgetFund?.length>1}">
   
        <div class="btn-group">           
        @for(f of budgetFund; track f.id){
        <button class="btn btn-white btn-sm" [ngStyle]="{'min-width': '120px'}" [class.active]="fundSelect ==f.fundCode" (click)="changeFund(f.fundCode)">Fondo {{f.fundCode}}</button>
        }
        </div>
      </div>
    }   

    <div class="col-12 mb-3 col-md-6">   
        <div class=" d-md-flex fw-bold justify-content-end">
            <div class="mt-3">
                <div class="ms-md-4 mt-md-0 mt-e dropdown-toggle">
                    <a href="javascript:;" data-bs-toggle="dropdown"
                        class="text-decoration-none text-dark text-opacity-75"><i
                            class="fa fa-cog fa-fw me-1 text-dark text-opacity-50"></i> Opciones<b
                            class="caret"></b></a>

                    <div class="dropdown-menu">
                        <a (click)="exportToExcel()" class="dropdown-item">Exportar Excel</a>
                        @if(budgetStatus==2){
                        <div role="separator" class="dropdown-divider"></div>

                        <a (click)="openModalSettingAccount()" class="dropdown-item">Configurar Cuenta</a>
                        @if(budgetVersionSelected?.entityGroup=='IASD'&&
                        filter.departamentItemCode!=3){
                        <a (click)="openModalSettingDepartament()" class="dropdown-item">Configurar Departamento</a>
                        }
                    }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-budget-over-view [data]="items" [filterItemCode]="filter.departamentItemCode" [departament]="selectedDepartament"
[fundCode]="fundSelect"></app-budget-over-view>




<div class="panel p-4 mt-3">

    <div class="row  mt-0 align-items-center">
        <div class="col-12 col-md-6 mb-3 ">
            <ng-select [items]="dataListAccounts" [selectableGroup]="true" [hideSelected]="true" bindLabel="codeName"
                [closeOnSelect]="false" [dropdownPosition]="'bottom'" [multiple]="true" bindValue="id"
                (change)="changeNgSelectAccount()" placeholder="Filtrar por cuenta" [(ngModel)]="txtFindAccount"
                tabindex="1">
            </ng-select>
        </div>
        <div class="col-12 col-md-6 mb-3 ">
            <ng-select [items]="dataListDepartament" [selectableGroup]="true" [hideSelected]="true" bindLabel="codeName"
                [closeOnSelect]="false" [dropdownPosition]="'bottom'" [multiple]="true" bindValue="code"  [(ngModel)]="txtFindDepartament"
                (change)="changeNgSelectAccount()" placeholder="Filtrar por departamento"
                tabindex="2">
            </ng-select>
        </div>

    </div>
    @if(accounts.length==0&&isLoading==false){
    <div class="alert alert-danger mt-2">
        <strong>Advertencia!</strong> No se han configurado cuentas o departamentos.
    </div>
    }


    @if(accounts.length > 0){
    <div #tableData class="table-data">
        <table class="table table-sm ">
            <thead>
                <!-- Primera fila: Nombre del grupo -->
                <tr>
                    <th class="border-0 sticky-column-1"></th>
                    <th class="border-0 sticky-column-2"></th>
                    <th class="border-0 sticky-column-3"></th>
                    @for (group of fieldName; track group.parentCode; let i = $index) {
                    <th [attr.colspan]="group.subDepartaments.length" class="text-nowrap text-center"
                     [ngClass]="{
                    'border-0':group.parentName == '',
                    'bg-light': i % 2 === 0 && group.parentName != '',
                    'bg-secondary bg-opacity-20': i % 2 === 1 && group.parentName != ''
                }">
                        {{group.parentName}}
                    </th>
                    }
                </tr>
                <tr>
                    <th class="sticky-column-1 text-start" style="width: 140px;">N° Cuenta/Div</th>
                    <th class="sticky-column-2 ">Nombre Cuenta </th>
                    <th class="sticky-column-3 text-nowrap text-start">Total</th>
                    @for (group of fieldName; track group.parentCode; let i = $index) {
                    @for (d of group.subDepartaments; track d.id) {
                    <th [ngClass]="{
                        'bg-light': i % 2 === 0 && group.parentName != '',
                        'bg-secondary bg-opacity-20': i % 2 === 1 && group.parentName != ''
                      }">
                        <div class="text-center">
                            <strong>{{ d.departamentDisplayName }}
                                @if (d.departamentHint) {
                                <i class="fas fa-question-circle" ngbTooltip="{{ d.departamentHint }}" placement="top"
                                    [container]="'body'">
                                </i>
                                }
                            </strong><br>
                            <small>({{ d.departamentCode }})</small>
                        </div>
                    </th>
                    }
                    }


                </tr>
            </thead>
            <tbody>
                <!--muestra una tabla cargando mientras se estan cargado los datos-->
                @if(isLoading){
                @for( i of rows ;track $index){
                <tr class="tr-custom">
                    @for( i of cols ;track $index){
                    <td >
                        <p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p>
                    </td>
                    }
                </tr>
                }
                }
                @for(a of accounts; track a.id){
                <tr>
                    <td class="sticky-column-1 text-nowrap  align-middle">
                       <span>{{a.subAccountCode==-1?a.accountCode:a.accountCode+'/'+a.subAccountCode}}</span>
                    </td>
                    <td class="sticky-column-2 align-middle">
                        {{a.subAccountCode==-1?a.accountDisplayName:a.accountDisplayName+' - '+a.subAccountName}}
                        @if(a.accountHint){
                        <i class="fas fa-question-circle" ngbTooltip="{{a.accountHint}}" placement="right"
                            [container]="'body'">
                        </i>
                        }
                    </td>
                    <td class="sticky-column-3 text-nowrap bg-light align-middle text-start">
                        <span>${{a.totalValue| number: '1.0-0'}}</span>
                    </td>

                    @for(group of fieldName; track group.parentCode){
                    @for (d of group.subDepartaments; track d.id; let i = $index) {
                        <ng-template #popoverContent>
                            <div>
                              - Presupuestado {{ filter.year - 1 }}:
                              <strong>
                                ${{ getValue(
                                  d.departamentCode,
                                  findGroupByParentCode(a.departaments, group.parentCode)?.subDepartaments,
                                  'oldValue',
                                  d.departamentFundCode
                                ) | number: '1.0-0' }}
                              </strong>
                            </div>
                          </ng-template>

                    <td class="align-middle text-nowrap" >
                        @if(budgetStatus==2){
                            @if(getValue(d.departamentCode, findGroupByParentCode(a.departaments, group.parentCode)?.subDepartaments, 'oldValue',d.departamentFundCode)){
                        <input  type="text" [ngbPopover]="popoverContent"
                        popoverTitle="Referencia presupuestaria"
                        triggers="focus blur"
                        (keypress)="onlyNumber($event)"
                        #p="ngbPopover"
                        [container]="tableData.nativeElement"
                        placement="top"  [ngStyle]="{'min-width': '140px','box-shadow': '-4px 0 2px -2px rgba(0, 172, 172, 0.8)' }" class="form-control form-control-sm text-end "
                            (click)="selectAll($event,a,group.parentCode,d.departamentCode,d.departamentFundCode)"
                            (blur)="unSelectedDepartamentCode()"
                            (keypress)="onlyNumber($event)"
                            (focus)="toggleInput($event.target.value)"  
                            [value]="getValue(d.departamentCode, findGroupByParentCode(a.departaments, group.parentCode)?.subDepartaments, 'value',d.departamentFundCode) 
                            | number: '1.0-0'" (change)="changeValue($event,a,group.parentCode,d.departamentCode,d.departamentFundCode)" appNumberFormat />
                            
                        }
                            @else{
                            
                            <input  type="text"  [ngStyle]="{'min-width': '140px'}" class="form-control form-control-sm text-end "
                            (click)="selectAll($event,a,group.parentCode,d.departamentCode,d.departamentFundCode)"
                            (blur)="unSelectedDepartamentCode()"
                            (keypress)="onlyNumber($event)"
                            (focus)="toggleInput($event.target.value)"  
                            [value]="getValue(d.departamentCode, findGroupByParentCode(a.departaments, group.parentCode)?.subDepartaments, 'value',d.departamentFundCode) 
                            | number: '1.0-0'" (change)="changeValue($event,a,group.parentCode,d.departamentCode,d.departamentFundCode)" appNumberFormat />
                            }
                        }
                            @else {
                                <span [ngStyle]="{'min-width': '140px'}">{{getValue(d.departamentCode, findGroupByParentCode(a.departaments, group.parentCode)?.subDepartaments, 'value',d.departamentFundCode) 
                                | number: '1.0-0'}}</span>
                            }

                    </td>
                    }
                    }
                </tr>
                }
            </tbody>
            <tfoot>
                <tr>
                    <th class="sticky-column-1"></th>
                    <th class="sticky-column-2">Sub Totales</th>
                    <th class="sticky-column-3 text-start">
                        ${{getTotalFund() | number:'1.0-0'}}
                      </th>
                    @for(group of fieldName; track group.parentCode){
                    @for (d of group.subDepartaments; track d.id) {

                    <th class="text-end">
                        <small>$ {{getSubTotalValue(d.departamentCode,'valueTotal',d.departamentFundCode) | number:
                            '1.0-0'}}</small>
                    </th>
                    }
                    }
                </tr>
            </tfoot>
        </table>
    </div>
    }






</div>

}


<ng-template #modal_account let-c="close" let-d="dismiss" let-modal>
    <div class="modal-header">
        <h5 class="modal-title">tabla draggrag</h5>
        <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
            <span>&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-setting-field-salary></app-setting-field-salary>

    </div>

</ng-template>



<ng-template #modal_setting let-c="close" let-d="dismiss" let-modal>

    <div class="modal-header">
        <h5 class="modal-title">Configurar Sueldos</h5>
        <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
            <span>&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="panel-body panel-form">
            <form>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Código</label>
                    <div class="col-md-8">
                        <input type="text" names="names" class="form-control" tabindex="1" />
                    </div>
                </div>&nbsp;
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Nombre</label>
                    <div class="col-md-8">
                        <input type="text" names="names" class="form-control" tabindex="2" />
                    </div>
                </div>&nbsp;

            </form>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click')"><i
                class="fas fa-times"></i>&nbsp; Cerrar</button>
        <button type="button" class="btn btn-primary btn-sm" tabindex="4"><i
                class="fas fa-save"></i>&nbsp;Guardar</button>

    </div>
</ng-template>